
import styled from 'styled-components'

import COLORS from 'constants/colors'
import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


import BgOne from 'assets/images/backgrounds/bgr-news-block001.svg'
import BgTwo from 'assets/images/backgrounds/bgr-news-block002.svg'
import BgThree from 'assets/images/backgrounds/bgr-news-block003.svg'
import BgFour from 'assets/images/backgrounds/bgr-news-block004.svg'

import { Props } from './types'

/* eslint-disable import/prefer-default-export */
export const StyledCard = styled.div<Props>`
  border: 2px solid ${COLORS.BORDERS};
  padding: ${LAYOUT.VERTICALSPACEMOBILE} 20px;
  margin: 10px;
  max-width: 390px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${MEDIA.medium`
    padding: ${LAYOUT.VERTICALSPACE} 20px;
    min-height: 390px;
  `}

  ${(props): string => (props.bg === 'one' && `
    background-image: url(${BgOne});
    background-size: cover;
  `) || (props.bg === 'two' && `
    background-image: url(${BgTwo});
    background-size: cover;
  `) || (props.bg === 'three' && `
    background-image: url(${BgThree});
    background-size: cover;
  `) || (props.bg === 'four' && `
    background-image: url(${BgFour});
    background-size: cover;
  `) || ''}
`
